import { useEffect } from "react";
import MainPage from "../pages/MainPage";
import { useNavigate } from "react-router-dom";

export default function ResetPasswordRoute() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const uid = params.get("uid");
    const token = params.get("token");

    if (uid && token) {
      sessionStorage.setItem(
        "pwReset",
        JSON.stringify({ uid, token, ts: Date.now() })
      );
    }

    // ✅ czy jest uid/token czy nie — wracamy na stronę główną
    navigate("/", { replace: true });
  }, [navigate]);

  return null;
}
